import type { MissingGamesTab } from '../../../../types/features/games';

const MISSING_GAMES_TAB_PARAM = 'mg_tab';
const DEFAULT_MISSING_GAMES_TAB: MissingGamesTab = 'missing_games';

const validMissingGamesTabs = new Set<MissingGamesTab>([
  'missing_games',
  'plu_verification_pending',
  'missing_images',
]);

export const getMissingGamesTabFromSearchParams = (searchParams: URLSearchParams): MissingGamesTab => {
  const tab = searchParams.get(MISSING_GAMES_TAB_PARAM);

  if (validMissingGamesTabs.has(tab as MissingGamesTab)) {
    return tab as MissingGamesTab;
  }

  return DEFAULT_MISSING_GAMES_TAB;
};

export const buildMissingGamesTabSearchParams = (
  currentSearchParams: URLSearchParams,
  tab: MissingGamesTab,
): URLSearchParams => {
  const nextSearchParams = new URLSearchParams(currentSearchParams);

  if (tab === DEFAULT_MISSING_GAMES_TAB) {
    nextSearchParams.delete(MISSING_GAMES_TAB_PARAM);
  } else {
    nextSearchParams.set(MISSING_GAMES_TAB_PARAM, tab);
  }

  return nextSearchParams;
};
